import { AssetTypes } from "../backend/types/utils";
import i18n from "../services/i18n";
import { CreateInvestmentManageable, InvestmentManageable } from "../store/investment/types";
import { SaleManageable } from "../store/sale/types";
import { UserManageable } from "../store/user/types";

export const getStoragePersonalDetails = (): UserManageable => {
  const storageUserDetails = localStorage.getItem("userDetails");
  return storageUserDetails
    ? new UserManageable(JSON.parse(storageUserDetails))
    : new UserManageable(null);
};

export const getStorageCurrentInvestment = (): InvestmentManageable | null => {
  const storageInvestment = localStorage.getItem("currentInvestment");
  return storageInvestment
    ? JSON.parse(storageInvestment) as InvestmentManageable
    : null;
};

export const getStorageCurrentCreatedInvestment = (): CreateInvestmentManageable | null => {
  const storageCreatedInvestment = localStorage.getItem("currentCreatedInvestment");
  return storageCreatedInvestment
    ? JSON.parse(storageCreatedInvestment) as CreateInvestmentManageable
    : null;
};

export const getStorageCurrentSales = (): Map<AssetTypes, Array<SaleManageable>> => {
  const storageSales = localStorage.getItem("sales");
  if (storageSales) {
    let result = new Map(JSON.parse(storageSales)) as Map<AssetTypes, Array<SaleManageable>>;
    Object.values(AssetTypes).forEach((value) => {
      const rawAssetTypeSales = result.get(value);
      if (rawAssetTypeSales) {
        result.set(
          value,
          rawAssetTypeSales.map((sale: any) => new SaleManageable(sale))
        );
      }
    });
    return result;
  }

  const emptySales = new Map<AssetTypes, Array<SaleManageable>>();
  Object.values(AssetTypes).forEach((value) => {
    emptySales.set(
      value,
      new Array<SaleManageable>()
    );
  });

  return emptySales;
};

export const getStorageInvestments = () : Array<InvestmentManageable> => {
  const storageInvestments = localStorage.getItem("investments");
  return storageInvestments
    ? Array.from(JSON.parse(storageInvestments)).map((investment: any) => new InvestmentManageable(investment)) as Array<InvestmentManageable>
    : new Array<InvestmentManageable>();
}

export const getStorageToken = () => {
  return localStorage.getItem('token') || "";
}

export const getStorageLanguage = () => {
  return localStorage.getItem('language') || i18n.language || "de";
}